import { NGSModuleManager } from "~/core/manager";

import { Header } from "@modules";
import { Handbook } from "./modules/handbook";

const NGSScripts = new NGSModuleManager();

const headerModule = new Header();
const handbookModule = new Handbook();

// Register modules
NGSScripts.register(headerModule);
NGSScripts.register(handbookModule);

// Initialize scripts
NGSScripts.initialize();

const header = NGSScripts.get("header");
